import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMappedComponent, LazyMappedComponents, LazyConstants, LazyContentfulAccordionSection, LazyContentfulAnimation, LazyContentfulBadge, LazyContentfulCardCarouselSection, LazyContentfulColumns, LazyContentfulContentPage, LazyContentfulContentSection, LazyContentfulContentTabs, LazyContentfulCtaSection, LazyContentfulCustomHTML, LazyContentfulExperience, LazyContentfulHeadline, LazyContentfulHeroArticleSection, LazyContentfulHeroOverviewSection, LazyContentfulHeroProductSection, LazyContentfulHeroSections, LazyContentfulImage, LazyContentfulLink, LazyContentfulLinksGroup, LazyContentfulMediaTabs, LazyContentfulMultiExperience, LazyContentfulProductsListSection, LazyContentfulSpacer, LazyContentfulTable, LazyContentfulTabsSection, LazyContentfulTagCloudContainer, LazyContentfulTagOverviewSection, LazyContentfulTechnicalComponent, LazyContentfulTestimonialList, LazyContentfulTextImageTeaser, LazyContentfulTextImageTeaserList, LazyContentfulTextMedia, LazyContentfulTextTeaserCardList, LazyContentfulTile, LazyContentfulTiles, LazyContentfulVideo, LazyLibAudienceWidget, LazyLibBreadcrumb, LazyLibCircleFlag, LazyLibDiscontinuationList, LazyLibDownloadCenter, LazyLibErrorBoundary, LazyLibExternalTool, LazyLibGroupedSections, LazyLibHeroCanvas, LazyLibIFrame, LazyLibInactiveLocaleMessage, LazyLibInlineTypeformSurvey, LazyLibIrInvestorRelations, LazyLibIrInvestorRelationsLoadingSkeleton, LazyLibLazyLoad, LazyLibLocaleVersionOverlay, LazyLibLocaleVersionOverlayContainer, LazyLibPageContainer, LazyLibPageFooter, LazyLibPageHeader, LazyLibPardotForm, LazyLibProductEnrichmentAboveTabSection, LazyLibProductEnrichmentCenterSection, LazyLibProductEnrichmentFooterSection, LazyLibProductEnrichmentTabElement, LazyLibRegionSelector, LazyLibResolveError, LazyLibRichTextRenderer, LazyLibSearchDocumentCenterList, LazyLibSearchGlobalSearchPagination, LazyLibSearchPrimevue2Slider, LazyLibSearchProductSearch, LazyLibSearchProductSearchFilter, LazyLibSearchProductSearchPagination, LazyLibSearchResourcesFilter, LazyLibSearchResults, LazyLibSearchResultsSkeleton, LazyLibSearchInput, LazyLibSearchPage, LazyLibSearchSection, LazyLibSearchSoftwareCenter, LazyLibSoftwareCenter, LazyLibTabSections, LazyLibTestCameraForm, LazyLibToolsLensSelectorInModal, LazyLibTypeformSurvey, LazyMapping, LazyPrimeVueCheckbox, LazyPrimeVueFloatLabel, LazyPrimeVueIconField, LazyPrimeVueInputIcon, LazyPrimeVueInputNumber, LazyPrimeVueInputText, LazyPrimeVueRadioButton, LazyPrimeVueSelect, LazyPrimeVueSlider, LazyPrimeVueSplitButton, LazyPrimeVueColumn, LazyPrimeVueDataTable, LazyPrimeVuePopover, LazyPrimeVueForm } from '#components'
const lazyGlobalComponents = [
  ["MappedComponent", LazyMappedComponent],
["MappedComponents", LazyMappedComponents],
["Constants", LazyConstants],
["ContentfulAccordionSection", LazyContentfulAccordionSection],
["ContentfulAnimation", LazyContentfulAnimation],
["ContentfulBadge", LazyContentfulBadge],
["ContentfulCardCarouselSection", LazyContentfulCardCarouselSection],
["ContentfulColumns", LazyContentfulColumns],
["ContentfulContentPage", LazyContentfulContentPage],
["ContentfulContentSection", LazyContentfulContentSection],
["ContentfulContentTabs", LazyContentfulContentTabs],
["ContentfulCtaSection", LazyContentfulCtaSection],
["ContentfulCustomHTML", LazyContentfulCustomHTML],
["ContentfulExperience", LazyContentfulExperience],
["ContentfulHeadline", LazyContentfulHeadline],
["ContentfulHeroArticleSection", LazyContentfulHeroArticleSection],
["ContentfulHeroOverviewSection", LazyContentfulHeroOverviewSection],
["ContentfulHeroProductSection", LazyContentfulHeroProductSection],
["ContentfulHeroSections", LazyContentfulHeroSections],
["ContentfulImage", LazyContentfulImage],
["ContentfulLink", LazyContentfulLink],
["ContentfulLinksGroup", LazyContentfulLinksGroup],
["ContentfulMediaTabs", LazyContentfulMediaTabs],
["ContentfulMultiExperience", LazyContentfulMultiExperience],
["ContentfulProductsListSection", LazyContentfulProductsListSection],
["ContentfulSpacer", LazyContentfulSpacer],
["ContentfulTable", LazyContentfulTable],
["ContentfulTabsSection", LazyContentfulTabsSection],
["ContentfulTagCloudContainer", LazyContentfulTagCloudContainer],
["ContentfulTagOverviewSection", LazyContentfulTagOverviewSection],
["ContentfulTechnicalComponent", LazyContentfulTechnicalComponent],
["ContentfulTestimonialList", LazyContentfulTestimonialList],
["ContentfulTextImageTeaser", LazyContentfulTextImageTeaser],
["ContentfulTextImageTeaserList", LazyContentfulTextImageTeaserList],
["ContentfulTextMedia", LazyContentfulTextMedia],
["ContentfulTextTeaserCardList", LazyContentfulTextTeaserCardList],
["ContentfulTile", LazyContentfulTile],
["ContentfulTiles", LazyContentfulTiles],
["ContentfulVideo", LazyContentfulVideo],
["LibAudienceWidget", LazyLibAudienceWidget],
["LibBreadcrumb", LazyLibBreadcrumb],
["LibCircleFlag", LazyLibCircleFlag],
["LibDiscontinuationList", LazyLibDiscontinuationList],
["LibDownloadCenter", LazyLibDownloadCenter],
["LibErrorBoundary", LazyLibErrorBoundary],
["LibExternalTool", LazyLibExternalTool],
["LibGroupedSections", LazyLibGroupedSections],
["LibHeroCanvas", LazyLibHeroCanvas],
["LibIFrame", LazyLibIFrame],
["LibInactiveLocaleMessage", LazyLibInactiveLocaleMessage],
["LibInlineTypeformSurvey", LazyLibInlineTypeformSurvey],
["LibIrInvestorRelations", LazyLibIrInvestorRelations],
["LibIrInvestorRelationsLoadingSkeleton", LazyLibIrInvestorRelationsLoadingSkeleton],
["LibLazyLoad", LazyLibLazyLoad],
["LibLocaleVersionOverlay", LazyLibLocaleVersionOverlay],
["LibLocaleVersionOverlayContainer", LazyLibLocaleVersionOverlayContainer],
["LibPageContainer", LazyLibPageContainer],
["LibPageFooter", LazyLibPageFooter],
["LibPageHeader", LazyLibPageHeader],
["LibPardotForm", LazyLibPardotForm],
["LibProductEnrichmentAboveTabSection", LazyLibProductEnrichmentAboveTabSection],
["LibProductEnrichmentCenterSection", LazyLibProductEnrichmentCenterSection],
["LibProductEnrichmentFooterSection", LazyLibProductEnrichmentFooterSection],
["LibProductEnrichmentTabElement", LazyLibProductEnrichmentTabElement],
["LibRegionSelector", LazyLibRegionSelector],
["LibResolveError", LazyLibResolveError],
["LibRichTextRenderer", LazyLibRichTextRenderer],
["LibSearchDocumentCenterList", LazyLibSearchDocumentCenterList],
["LibSearchGlobalSearchPagination", LazyLibSearchGlobalSearchPagination],
["LibSearchPrimevue2Slider", LazyLibSearchPrimevue2Slider],
["LibSearchProductSearch", LazyLibSearchProductSearch],
["LibSearchProductSearchFilter", LazyLibSearchProductSearchFilter],
["LibSearchProductSearchPagination", LazyLibSearchProductSearchPagination],
["LibSearchResourcesFilter", LazyLibSearchResourcesFilter],
["LibSearchResults", LazyLibSearchResults],
["LibSearchResultsSkeleton", LazyLibSearchResultsSkeleton],
["LibSearchInput", LazyLibSearchInput],
["LibSearchPage", LazyLibSearchPage],
["LibSearchSection", LazyLibSearchSection],
["LibSearchSoftwareCenter", LazyLibSearchSoftwareCenter],
["LibSoftwareCenter", LazyLibSoftwareCenter],
["LibTabSections", LazyLibTabSections],
["LibTestCameraForm", LazyLibTestCameraForm],
["LibToolsLensSelectorInModal", LazyLibToolsLensSelectorInModal],
["LibTypeformSurvey", LazyLibTypeformSurvey],
["Mapping", LazyMapping],
["PrimeVueCheckbox", LazyPrimeVueCheckbox],
["PrimeVueFloatLabel", LazyPrimeVueFloatLabel],
["PrimeVueIconField", LazyPrimeVueIconField],
["PrimeVueInputIcon", LazyPrimeVueInputIcon],
["PrimeVueInputNumber", LazyPrimeVueInputNumber],
["PrimeVueInputText", LazyPrimeVueInputText],
["PrimeVueRadioButton", LazyPrimeVueRadioButton],
["PrimeVueSelect", LazyPrimeVueSelect],
["PrimeVueSlider", LazyPrimeVueSlider],
["PrimeVueSplitButton", LazyPrimeVueSplitButton],
["PrimeVueColumn", LazyPrimeVueColumn],
["PrimeVueDataTable", LazyPrimeVueDataTable],
["PrimeVuePopover", LazyPrimeVuePopover],
["PrimeVueForm", LazyPrimeVueForm],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
